"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskCommand = void 0;
var AsteriskCommand;
(function (AsteriskCommand) {
    AsteriskCommand["Answer"] = "ANSWER";
    AsteriskCommand["Hangup"] = "HANGUP";
    AsteriskCommand["Exit"] = "EXIT";
    AsteriskCommand["SetVariable"] = "SET_VARIABLE";
    AsteriskCommand["GetDigits"] = "GET_DIGITS";
    AsteriskCommand["GetVariable"] = "GET_VARIABLE";
    AsteriskCommand["GetFunctionResponse"] = "GET_FUNCTION_RESPONSE";
    AsteriskCommand["SayNumber"] = "SAY_NUMBER";
    AsteriskCommand["SayDigits"] = "SAY_DIGITS";
    AsteriskCommand["SayAlpha"] = "SAY_ALPHA";
    AsteriskCommand["SayPhonetic"] = "SAY_PHONETIC";
    AsteriskCommand["StartRecording"] = "START_RECORDING";
    AsteriskCommand["StopRecording"] = "STOP_RECORDING";
    AsteriskCommand["Playback"] = "PLAYBACK";
    AsteriskCommand["SetQueue"] = "SET_QUEUE";
    AsteriskCommand["Goto"] = "GOTO";
    AsteriskCommand["ExternalDial"] = "EXTERNAL_DIAL";
    AsteriskCommand["InternalDial"] = "INTERNAL_DIAL";
    AsteriskCommand["VoiceMail"] = "VOICE_MAIL";
})(AsteriskCommand = exports.AsteriskCommand || (exports.AsteriskCommand = {}));
